import i18n from 'i18next';
import React from 'react';
import {Manage} from "@/Pages/Manage/Manage";
import Authenticated from "@/Layouts/Authenticated";
import People from "@/Pages/Manage/People";
import "@/../sass/authenticated/users.scss";

const Users = (props) => {

    return (
        <Manage className="users" title={i18n.t('manage.people')}>
            <People auth={props.auth} />
        </Manage>
    )
}

Users.layout = page => <Authenticated children={page}></Authenticated>

export default Users
